import {TheRave} from "../TheRave";
import {TimelineLite, TweenLite} from "gsap";
import {Layers, TheRaveLayers} from "./TheRaveLayers";
import {TheRaveReelView} from "../reels/TheRaveReelView";
import {TheRaveSound} from "../sound/TheRaveSound";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {APIBetType} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetType";

export class NearWinPresentation extends PIXI.Container {
    private _isPlaying: boolean = false;
    private _endSoundPlayed: boolean = true;
    private _currentReel: number = -1;
    private _isQuickStop: boolean = false;
    private _container: PIXI.Container;
    private _nearWinO: PIXI.Sprite;
    private _nearWinSpine: PIXI.spine.Spine;
    private _nearWinSpineBlend: PIXI.spine.Spine;

    constructor() {
        super();
        this._container = new PIXI.Container();
    }

    public start(reelId: number, nearwinStart:boolean = false): TimelineLite {
        if(this._isQuickStop){
            return new TimelineLite();
        }
        this._container.alpha = 0;
        this._container.visible = true;
        if (this._nearWinSpine) {
            this._nearWinSpine.destroy();
            this._nearWinSpineBlend.destroy();
        } else {
            this._nearWinO = new PIXI.Sprite(TheRave.assetLoader.getTextures("nearwinO")[0]);
            this._nearWinO.name = "nearwinO";
        }
        this._nearWinSpine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("nearwin"));
        this._nearWinSpine.name = "nearwin";
        this._nearWinSpineBlend = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("nearwinBlend"));
        this._nearWinSpine.name = "nearwinBlend";
        this._container.addChild(this._nearWinSpine);
        this._container.addChild(this._nearWinSpineBlend);
        this._container.addChild(this._nearWinO);


        const posX: number = TheRaveReelView.REEL_LEFT + TheRaveReelView.SYMBOL_WIDTH * reelId,
            posY: number = 420;
        this._nearWinSpineBlend.position.set(posX, posY);
        this._nearWinSpine.position.set(posX, posY);
        this._nearWinO.position.set(posX, posY);
        TheRaveLayers.getLayer(Layers.NEAR_WIN)?.addChild(this._container);
        //console.log("nearwin on reel: " +reelId)
        const tl = new TimelineLite();
        tl.add([
            TweenLite.to(this._container, 0.4,{alpha:1}),
            TheRave.fullScreenDimLayer.startReelAreaDimmer(),
            () => {
                //TheRave.audioVisualiser.resetFilters();
                //TheRave.audioVisualiser.applyFilter('lowpass');
                if(nearwinStart){
                    TheRaveSound.playSoundEffect("scatterAnticipation", 0);
                    TheRaveSound.anticipationStart();
                }
                this._isPlaying = true;
                this._endSoundPlayed = false;

                this._currentReel = reelId;
                this._nearWinSpineBlend.state.setAnimation(0, "start", false);
                this._nearWinSpine.state.setAnimation(0, "loop", true);
               TheRave.reels[reelId].reelView.liftAboveDimmer();

            }]);
        tl.add(() => {
            this._nearWinSpineBlend.state.setAnimation(0, "loop", true)
        }, 0.5);
        return tl;
    }

    public onContinueNearWinAnimation(reelId: number): void {
        if (this._isPlaying && reelId < 4) {
            TheRave.reels[reelId].reelView.resetHighContainerLayer();
            this.start(reelId + 1);
        }
    }

    public reset(quickStop:boolean = false): void {
        if(this._isPlaying){
            this.stopAnticipationSound();
            this._isPlaying = false;
            TheRave.reels[this._currentReel].reelView.resetHighContainerLayer();
            this._currentReel = -1;
            if (this._nearWinSpine) {
                TweenLite.to(this._container, 0.5,{alpha:0});
                TheRaveSound.stopSoundEffect("scatterAnticipation");
                TheRaveSound.anticipationStop();
                TheRave.fullScreenDimLayer.stopReelAreaDimmer();
                this._nearWinSpine.state.setEmptyAnimation(0, 0);
                this._nearWinSpineBlend.state.setEmptyAnimation(0, 0);
            }
        }else{
            this._container.visible = false;
        }
        this._isQuickStop = quickStop;
    }

    public stopAnticipationSound():void{
        if(!this._isPlaying){
            return;
        }

        if(this._endSoundPlayed){
            return;
        }
        TheRaveSound.playSoundEffect(`scatterAnticipation${TheRave.model.nextMode!==GameMode.NORMAL?"Win":"Fail"}`, 0);
        //TheRave.audioVisualiser.resetFilters();
        this._endSoundPlayed = true;
    }
}
